import React from 'react'
import { ActionIcon, Button, Group, Tooltip } from '@mantine/core'
import { IconLayoutSidebarLeftCollapse } from '@tabler/icons-react'

type TopProgressProps = {
  steps: {
    label: string
    color: string
  }[]
  fileRequired: boolean
  sideProgressOpened: boolean
  stepIndex: number
  setStepIndex: (idx: number) => void
  onOpen: () => void
}

export const TopProgress = ({ steps, fileRequired, stepIndex, setStepIndex, sideProgressOpened, onOpen  }: TopProgressProps) => {
  return (
    <Group wrap='nowrap' p='25px 25px 10px'>
      { steps.map((step, idx) =>
        <Tooltip label='Must upload a match priority flile before continuing' disabled={!fileRequired || idx === 0}>
          <Button
            disabled={fileRequired && idx !== 0}
            color={stepIndex < idx ? 'blueGrey' : step.color}
            c={stepIndex < idx ? 'darkGrey' : 'white'}
            key={step.label}
            onClick={() => setStepIndex(idx)}
            w='100%'
          >
            {`${idx+1}. ${step.label}`}
          </Button>
        </Tooltip>
      )}
      {!sideProgressOpened &&
        <Group wrap='nowrap'>
          <Button w='100%' variant='transparent' color="black" onClick={onOpen}>Workflow Stages</Button>
          <ActionIcon
            onClick={onOpen}
            variant="outline"
            style={{ borderRadius: 4, borderColor: '#d5e0ea', borderWidth: 2 }}
            color='black'
            size={50}
          >
            <IconLayoutSidebarLeftCollapse size={20} />
          </ActionIcon>
        </Group>
      }
    </Group>
  )
}
